// Absurd style - nonsensical, random, weird
export const absurdPrefixes = [
    "Potato", "Toaster", "Brick", "Spoon", "Muffin", "Sock", "Pickle", "Banana", "Cheese", "Noodle",
    "Blob", "Fizz", "Glorp", "Splatch", "Wiggle", "Zonk", "Blorp", "Cabbage", "Duck", "Lamp",
    "Pudding", "Taco", "Waffle", "Biscuit", "Donut", "Bagel", "Spatula", "Bucket", "Mop", "Soap"
];

export const absurdSuffixes = [
    "face", "head", "nose", "pants", "bottom", "feet", "brain", "juice", "sauce", "cake",
    "monster", "goblin", "wizard", "ninja", "pirate", "chicken", "monkey", "weasel", "hamster", "goose",
    "tron", "bot", "zilla", "saurus", "nator", "master", "king", "queen", "lord", "dude"
];

export const trAbsurdPrefixes = [
    "Patates", "Tost", "Tuğla", "Kaşık", "Kek", "Çorap", "Turşu", "Muz", "Peynir", "Erişte",
    "Vıcık", "Fıs", "Glop", "Şap", "Kıpır", "Zonk", "Blorp", "Lahana", "Ördek", "Lamba",
    "Puding", "Dürüm", "Gofret", "Bisküvi", "Simit", "Poğaça", "Spatula", "Kova", "Paspas", "Sabun"
];

export const trAbsurdSuffixes = [
    "surat", "kafa", "burun", "pantolon", "pop", "ayak", "beyin", "suyu", "sos", "kek",
    "canavar", "cin", "büyücü", "ninjia", "korsan", "tavuk", "maymun", "gelincik", "hamster", "kaz",
    "tron", "bot", "zilla", "zor", "natör", "usta", "kral", "kraliçe", "bey", "dayı"
];

export const frAbsurdPrefixes = [
    "Patate", "Grille", "Brique", "Cuillère", "Muffin", "Chaussette", "Cornichon", "Banane", "Fromage", "Nouilli",
    "Blob", "Fizz", "Glorp", "Splatch", "Wiggle", "Zonk", "Blorp", "Chou", "Canard", "Lampe",
    "Puding", "Tacos", "Gaufre", "Biscuit", "Beignet", "Bagel", "Spatule", "Seau", "Vadrouille", "Savon"
];

export const frAbsurdSuffixes = [
    "tête", "visage", "nez", "pantalon", "fesses", "pieds", "cerveau", "jus", "sauce", "gâteau",
    "monstre", "gobelin", "sorcier", "ninja", "pirate", "poulet", "singe", "belette", "hamster", "oie",
    "tron", "bot", "zilla", "saurus", "nator", "maître", "roi", "reine", "seigneur", "mec"
];


// Silly style - playful, childish, whimsical
export const sillyPrefixes = [
    "Mc", "Sir", "Lady", "Captain", "Professor", "Doctor", "Mister", "Miss", "Baron", "Duke",
    "Happy", "Jolly", "Bouncy", "Fluffy", "Fuzzy", "Sparkly", "Giggly", "Wobbly", "Silly", "Crazy",
    "Super", "Mega", "Ultra", "Hyper", "Turbo", "Power", "Wonder", "Magic", "Epic", "Cool"
];

export const sillySuffixes = [
    "Boop", "Bop", "Bam", "Zap", "Zip", "Zoom", "Pow", "Wow", "Yay", "Wee",
    "Doodle", "Noodle", "Poodle", "Strudel", "Waddle", "Cuddle", "Snuggle", "Giggle", "Wiggle", "Jiggle",
    "Pop", "Hop", "Mop", "Top", "Cop", "Drop", "Flop", "Plop", "Stop", "Shop"
];

export const trSillyPrefixes = [
    "Bay", "Bayan", "Kaptan", "Profesör", "Doktor", "Efendi", "Hanım", "Baron", "Dük",
    "Mutlu", "Neşeli", "Zıpzıp", "Pofuduk", "Tüylü", "Işıltılı", "Kıkırdak", "Titrek", "Şapşal", "Çılgın",
    "Süper", "Mega", "Ultra", "Hiper", "Turbo", "Güçlü", "Harika", "Sihirli", "Epik", "Havalı"
];

export const trSillySuffixes = [
    "Bup", "Bop", "Bam", "Zap", "Zip", "Vın", "Pat", "Vay", "Hey", "Viy",
    "Düdük", "Erişte", "Kaniş", "Börek", "Paytak", "Kucak", "Sokulgan", "Gülcük", "Oynak", "Titrek",
    "Pop", "Hop", "Mop", "Top", "Kop", "Damla", "Flop", "Plop", "Dur", "Dükkan"
];

export const frSillyPrefixes = [
    "Mc", "Sir", "Dame", "Capitaine", "Professeur", "Docteur", "Monsieur", "Mademoiselle", "Baron", "Duc",
    "Joyeux", "Gai", "Rebondi", "Duveteux", "Flou", "Brillant", "Rieur", "Bancal", "Idiot", "Fou",
    "Super", "Méga", "Ultra", "Hyper", "Turbo", "Puissance", "Merveille", "Magie", "Épique", "Cool"
];

export const frSillySuffixes = [
    "Boop", "Bop", "Bam", "Zap", "Zip", "Zoom", "Pow", "Wow", "Yay", "Wee",
    "Gribouille", "Nouilles", "Caniche", "Strudel", "Dandin", "Câlin", "Nid", "Rire", "Remuer", "Gigoter",
    "Pop", "Hop", "Mop", "Top", "Cop", "Goutte", "Flop", "Plop", "Stop", "Boutique"
];

// Goofy names - full names that sound funny
export const goofyNames = [
    "Boaty McBoatface",
    "Sir Wiggles a Lot",
    "Professor Pumpernickel",
    "Captain Underpants",
    "Doctor Doofenshmirtz",
    "Benedict Cumberbatch", // Just kidding, but names like this
    "Engelbert Humperdinck",
    "SpongeBob SquarePants",
    "Peppa Pig",
    "Scooby Doo",
    "Shaggy Rogers",
    "Homer Simpson",
    "Peter Griffin",
    "Stan Smith",
    "Eric Cartman"
];

export const trGoofyNames = [
    "Temel Reis",
    "Dursun Çavuş",
    "Nasreddin Hoca",
    "Keloğlan",
    "İbiş",
    "Karagöz",
    "Hacivat",
    "Recep İvedik",
    "Şaban Oğlu Şaban",
    "Turist Ömer",
    "Güdük Necmi",
    "İnek Şaban",
    "Damat Ferit",
    "Kel Mahmut",
    "Badi Ekrem"
];

export const frGoofyNames = [
    "Astérix",
    "Obélix",
    "Tintin",
    "Milou",
    "Capitaine Haddock",
    "Gaston Lagaffe",
    "Marsupilami",
    "Iznogoud",
    "Lucky Luke",
    "Jolly Jumper",
    "Rantanplan",
    "Spirou",
    "Fantasio",
    "Boule",
    "Bill"
];

// Spanish Funny Names
export const esAbsurdPrefixes = [
    "Patata", "Tostadora", "Ladrillo", "Cuchara", "Magdalena", "Calcetín", "Pepinillo", "Plátano", "Queso", "Fideo",
    "Globo", "Burbuja", "Glop", "Churro", "Meneos", "Zonk", "Blorp", "Repollo", "Pato", "Lámpara",
    "Pudín", "Taco", "Gofre", "Galleta", "Rosquilla", "Espátula", "Cubo", "Fregona", "Jabón", "Morcilla"
];

export const esAbsurdSuffixes = [
    "cara", "cabeza", "nariz", "pantalón", "trasero", "pies", "cerebro", "jugo", "salsa", "pastel",
    "monstruo", "duende", "mago", "ninja", "pirata", "pollo", "mono", "comadreja", "hámster", "ganso",
    "trón", "bot", "zilla", "saurus", "nator", "maestro", "rey", "reina", "señor", "tío"
];

export const esSillyPrefixes = [
    "Don", "Doña", "Capitán", "Profesor", "Doctor", "Señor", "Señorita", "Barón", "Duque",
    "Feliz", "Alegre", "Saltarín", "Esponjoso", "Peludo", "Brillante", "Risueño", "Tambaleante", "Tonto", "Loco",
    "Súper", "Mega", "Ultra", "Híper", "Turbo", "Poder", "Maravilla", "Mágico", "Épico", "Genial"
];

export const esSillySuffixes = [
    "Bup", "Bop", "Bam", "Zap", "Zip", "Zum", "Pow", "Wow", "Yay", "Wii",
    "Garabato", "Fideos", "Caniche", "Strudel", "Pato", "Abrazo", "Achuchón", "Risita", "Meneo", "Temblor",
    "Pop", "Hop", "Mop", "Top", "Cop", "Gota", "Flop", "Plop", "Stop", "Shop"
];

export const esGoofyNames = [
    "Don Quijote",
    "Sancho Panza",
    "El Chavo del Ocho",
    "Cantinflas",
    "Mortadelo",
    "Filemón",
    "Zipi y Zape",
    "Bola de Dragón",
    "Señor Barriga",
    "Quico Tontón",
    "Profesor Bacterio",
    "Super López",
    "Rompetechos",
    "Carpanta",
    "Bananero McBanana"
];

// German Funny Names
export const deAbsurdPrefixes = [
    "Kartoffel", "Toaster", "Ziegel", "Löffel", "Muffin", "Socke", "Gurke", "Banane", "Käse", "Nudel",
    "Klops", "Brause", "Glorp", "Klatsch", "Wackel", "Zonk", "Blorp", "Kohl", "Ente", "Lampe",
    "Pudding", "Brezel", "Waffel", "Keks", "Donut", "Bagel", "Spachtel", "Eimer", "Wischmop", "Seife"
];

export const deAbsurdSuffixes = [
    "gesicht", "kopf", "nase", "hose", "hintern", "fuß", "hirn", "saft", "soße", "kuchen",
    "monster", "kobold", "zauberer", "ninja", "pirat", "huhn", "affe", "wiesel", "hamster", "gans",
    "tron", "bot", "zilla", "saurus", "nator", "meister", "könig", "königin", "herr", "typ"
];

export const deSillyPrefixes = [
    "Herr", "Frau", "Kapitän", "Professor", "Doktor", "Meister", "Fräulein", "Baron", "Herzog",
    "Fröhlich", "Lustig", "Hüpf", "Flauschig", "Wuschel", "Glitzer", "Kicher", "Wackel", "Albern", "Verrückt",
    "Super", "Mega", "Ultra", "Hyper", "Turbo", "Power", "Wunder", "Magisch", "Episch", "Cool"
];

export const deSillySuffixes = [
    "Bup", "Bop", "Bam", "Zap", "Zip", "Zoom", "Pow", "Wow", "Juh", "Wii",
    "Doodle", "Nudel", "Pudel", "Strudel", "Watschel", "Kuschel", "Schnuckel", "Kicher", "Wackel", "Zappel",
    "Pop", "Hop", "Mop", "Top", "Cop", "Tropf", "Flop", "Plop", "Stop", "Shop"
];

export const deGoofyNames = [
    "Werner Beinhart",
    "Max und Moritz",
    "Pumuckl",
    "Paulchen Panther",
    "Biene Maja",
    "Wickie",
    "Käpt'n Blaubär",
    "Fix und Foxi",
    "Lurchi",
    "Benjamin Blümchen",
    "Bibi Blocksberg",
    "Bernd das Brot",
    "Der rosarote Panther",
    "Struwwelpeter",
    "Baron Münchhausen"
];

// Portuguese Funny Names
export const ptAbsurdPrefixes = [
    "Batata", "Torradeira", "Tijolo", "Colher", "Bolinho", "Meia", "Pepino", "Banana", "Queijo", "Macarrão",
    "Bolha", "Efervescente", "Glorp", "Splash", "Bamboleio", "Zonk", "Blorp", "Repolho", "Pato", "Lâmpada",
    "Pudim", "Taco", "Waffle", "Biscoito", "Rosquinha", "Espátula", "Balde", "Esfregão", "Sabão", "Pastel"
];

export const ptAbsurdSuffixes = [
    "cara", "cabeça", "nariz", "calça", "bumbum", "pé", "cérebro", "suco", "molho", "bolo",
    "monstro", "duende", "mago", "ninja", "pirata", "galinha", "macaco", "doninha", "hamster", "ganso",
    "tron", "bot", "zilla", "saurus", "nator", "mestre", "rei", "rainha", "senhor", "cara"
];

export const ptSillyPrefixes = [
    "Senhor", "Senhora", "Capitão", "Professor", "Doutor", "Mestre", "Senhorita", "Barão", "Duque",
    "Feliz", "Alegre", "Saltitante", "Fofinho", "Peludo", "Brilhante", "Risonho", "Bambo", "Bobo", "Doido",
    "Super", "Mega", "Ultra", "Hiper", "Turbo", "Poder", "Maravilha", "Mágico", "Épico", "Legal"
];

export const ptSillySuffixes = [
    "Bup", "Bop", "Bam", "Zap", "Zip", "Zum", "Pow", "Wow", "Yay", "Wii",
    "Rabisco", "Macarrão", "Poodle", "Strudel", "Gingado", "Abraço", "Chamego", "Risada", "Remelexo", "Tremor",
    "Pop", "Hop", "Mop", "Top", "Cop", "Gota", "Flop", "Plop", "Stop", "Shop"
];

export const ptGoofyNames = [
    "Zé Carioca",
    "Chico Bento",
    "Cebolinha",
    "Cascão",
    "Magali",
    "Mônica",
    "Papa-Léguas",
    "Pica-Pau",
    "Chapolim Colorado",
    "Seu Madruga",
    "Nhonho",
    "Professor Girafales",
    "Seu Barriga",
    "Kiko Piripiri",
    "Capitão Caverna"
];

// Arabic Funny Names
export const arAbsurdPrefixes = [
    "بطاطا", "محمصة", "طوبة", "ملعقة", "كعكة", "جورب", "مخلل", "موز", "جبنة", "شعيرية",
    "فقاعة", "فوّارة", "غلوب", "طراطيش", "هزهزة", "زونك", "بلورب", "ملفوف", "بطة", "مصباح",
    "بودينغ", "فلافل", "وافل", "بسكويت", "دونات", "كعك", "ملعقة", "دلو", "ممسحة", "صابون"
];

export const arAbsurdSuffixes = [
    "وجه", "رأس", "أنف", "بنطلون", "مؤخرة", "قدم", "دماغ", "عصير", "صلصة", "كعكة",
    "وحش", "عفريت", "ساحر", "نينجا", "قرصان", "دجاجة", "قرد", "ابن عرس", "هامستر", "إوزة",
    "ترون", "بوت", "زيلا", "صوروس", "ناتور", "سيد", "ملك", "ملكة", "أمير", "عم"
];

export const arSillyPrefixes = [
    "سيد", "سيدة", "كابتن", "بروفيسور", "دكتور", "أستاذ", "آنسة", "بارون", "دوق",
    "سعيد", "مرح", "نطاط", "منفوش", "أشعث", "لامع", "ضحوك", "مترنح", "سخيف", "مجنون",
    "سوبر", "ميغا", "ألترا", "هايبر", "توربو", "قوة", "عجيب", "سحري", "أسطوري", "رائع"
];

export const arSillySuffixes = [
    "بوب", "بوب", "بام", "زاب", "زيب", "زووم", "باو", "واو", "ياي", "وي",
    "خربشة", "نودل", "كلب", "شتروديل", "تمايل", "حضن", "دلع", "ضحكة", "هزة", "رجرجة",
    "بوب", "هوب", "موب", "توب", "كوب", "قطرة", "فلوب", "بلوب", "ستوب", "شوب"
];

export const arGoofyNames = [
    "جحا",
    "أبو الهول",
    "علاء الدين",
    "سندباد",
    "أبو نواس",
    "كسلان بك",
    "فلّة",
    "سمسم",
    "بطوطة",
    "غرندايزر",
    "كابتن ماجد",
    "سنان",
    "أدهم",
    "عنتر المهذار",
    "أبو ضحكة"
];

// Hindi Funny Names
export const hiAbsurdPrefixes = [
    "आलू", "टोस्टर", "ईंट", "चम्मच", "मफिन", "मोजा", "अचार", "केला", "पनीर", "नूडल",
    "बुलबुला", "फिज़", "ग्लोर्प", "छप", "हिलना", "ज़ोंक", "ब्लोर्प", "गोभी", "बतख", "लैम्प",
    "खीर", "समोसा", "वफ़ल", "बिस्कुट", "डोनट", "बेगल", "कड़छी", "बाल्टी", "पोछा", "साबुन"
];

export const hiAbsurdSuffixes = [
    "चेहरा", "सिर", "नाक", "पैंट", "पिछवाड़ा", "पैर", "दिमाग", "रस", "चटनी", "केक",
    "राक्षस", "भूत", "जादूगर", "निंजा", "समुद्री डाकू", "मुर्गा", "बंदर", "नेवला", "हम्सटर", "हंस",
    "ट्रोन", "बॉट", "ज़िल्ला", "सॉरस", "नेटर", "उस्ताद", "राजा", "रानी", "साहब", "भाई"
];

export const hiSillyPrefixes = [
    "श्रीमान", "श्रीमती", "कप्तान", "प्रोफेसर", "डॉक्टर", "महोदय", "सुश्री", "बारन", "ड्यूक",
    "खुश", "मस्त", "उछलू", "फुलझड़ी", "रोएंदार", "चमकीला", "हंसोड़", "लड़खड़ा", "सिल्ली", "पागल",
    "सुपर", "मेगा", "अल्ट्रा", "हाइपर", "टर्बो", "पावर", "अजूबा", "जादुई", "एपिक", "कूल"
];

export const hiSillySuffixes = [
    "बूप", "बॉप", "बैम", "ज़ैप", "ज़िप", "ज़ूम", "पाउ", "वाउ", "याय", "वी",
    "डूडल", "नूडल", "पूडल", "स्ट्रूडल", "वैडल", "कडल", "स्नगल", "गिगल", "विगल", "जिगल",
    "पॉप", "हॉप", "मॉप", "टॉप", "कॉप", "ड्रॉप", "फ्लॉप", "प्लॉप", "स्टॉप", "शॉप"
];

export const hiGoofyNames = [
    "मोटू पतलू",
    "छोटा भीम",
    "शक्तिमान",
    "चाचा चौधरी",
    "साबू",
    "बिल्लू",
    "पिंकी",
    "चंपक चाचा",
    "गोबर गणेश",
    "ढोलू मोलू",
    "भोलू प्रसाद",
    "पपलू पागल",
    "टिक्कू राम",
    "गप्पू शर्मा",
    "लड्डू सिंह"
];

// Japanese Funny Names
export const jaAbsurdPrefixes = [
    "ジャガイモ", "トースター", "レンガ", "スプーン", "マフィン", "靴下", "漬物", "バナナ", "チーズ", "麺",
    "ブロブ", "シュワ", "グロープ", "バシャ", "ウィグル", "ゾンク", "ブロープ", "キャベツ", "アヒル", "ランプ",
    "プリン", "タコヤキ", "ワッフル", "ビスケット", "ドーナツ", "おにぎり", "しゃもじ", "バケツ", "モップ", "石鹸"
];

export const jaAbsurdSuffixes = [
    "顔", "頭", "鼻", "パンツ", "お尻", "足", "脳", "ジュース", "ソース", "ケーキ",
    "モンスター", "ゴブリン", "魔法使い", "忍者", "海賊", "チキン", "猿", "いたち", "ハムスター", "ガチョウ",
    "トロン", "ボット", "ジラ", "ザウルス", "ネーター", "マスター", "王", "女王", "殿", "さん"
];

export const jaSillyPrefixes = [
    "殿", "姫", "キャプテン", "教授", "博士", "先生", "お嬢", "男爵", "公爵",
    "ハッピー", "陽気", "ぴょん", "ふわふわ", "もこもこ", "キラキラ", "ゲラゲラ", "ふらふら", "おバカ", "クレイジー",
    "スーパー", "メガ", "ウルトラ", "ハイパー", "ターボ", "パワー", "ワンダー", "マジック", "エピック", "クール"
];

export const jaSillySuffixes = [
    "ブープ", "ボップ", "バム", "ザップ", "ジップ", "ズーム", "パウ", "ワオ", "ヤー", "ウィー",
    "ドゥードル", "ヌードル", "プードル", "シュトルーデル", "ワドル", "カドル", "スナグル", "ギグル", "ウィグル", "ジグル",
    "ポップ", "ホップ", "モップ", "トップ", "コップ", "ドロップ", "フロップ", "プロップ", "ストップ", "ショップ"
];

export const jaGoofyNames = [
    "ドラえもん",
    "クレヨンしんちゃん",
    "アンパンマン",
    "バイキンマン",
    "サザエさん",
    "磯野カツオ",
    "野比のび太",
    "ちびまる子ちゃん",
    "お茶の水博士",
    "バカボンのパパ",
    "おそ松くん",
    "ケロロ軍曹",
    "ポンコツクエスト",
    "珍遊記",
    "ボボボーボ・ボーボボ"
];

// Korean Funny Names
export const koAbsurdPrefixes = [
    "감자", "토스터", "벽돌", "숟가락", "머핀", "양말", "피클", "바나나", "치즈", "국수",
    "방울", "톡톡", "글로프", "철퍽", "흔들", "쫑크", "블로프", "양배추", "오리", "램프",
    "푸딩", "떡볶이", "와플", "비스킷", "도넛", "주먹밥", "주걱", "양동이", "대걸레", "비누"
];

export const koAbsurdSuffixes = [
    "얼굴", "머리", "코", "바지", "엉덩이", "발", "뇌", "주스", "소스", "케이크",
    "괴물", "도깨비", "마법사", "닌자", "해적", "닭", "원숭이", "족제비", "햄스터", "거위",
    "트론", "봇", "질라", "사우루스", "네이터", "달인", "왕", "여왕", "님", "형"
];

export const koSillyPrefixes = [
    "씨", "님", "선장", "교수", "박사", "선생", "양", "남작", "공작",
    "해피", "즐거운", "깡충", "폭신", "보송", "반짝", "킥킥", "비틀", "바보", "미친",
    "슈퍼", "메가", "울트라", "하이퍼", "터보", "파워", "원더", "매직", "에픽", "쿨"
];

export const koSillySuffixes = [
    "부프", "밥", "뱀", "잽", "집", "줌", "파우", "와우", "야이", "위",
    "두들", "누들", "푸들", "슈트루델", "뒤뚱", "안아", "꼬옥", "킥킥", "흔들", "지글",
    "팝", "홉", "몹", "탑", "캅", "드롭", "플롭", "플롭", "스톱", "숍"
];

export const koGoofyNames = [
    "뽀로로",
    "짱구",
    "둘리",
    "도우너",
    "또치",
    "희동이",
    "코코몽",
    "라바",
    "핑구",
    "뚝딱이",
    "번개맨",
    "땡칠이",
    "깜박이",
    "어리버리",
    "우당탕탕"
];

// Indonesian Funny Names
export const idAbsurdPrefixes = [
    "Kentang", "Pemanggang", "Bata", "Sendok", "Muffin", "Kaus Kaki", "Acar", "Pisang", "Keju", "Mie",
    "Gelembung", "Busa", "Glorp", "Ceprot", "Goyang", "Zonk", "Blorp", "Kubis", "Bebek", "Lampu",
    "Puding", "Bakso", "Wafel", "Biskuit", "Donat", "Kerupuk", "Spatula", "Ember", "Pel", "Sabun"
];

export const idAbsurdSuffixes = [
    "muka", "kepala", "hidung", "celana", "pantat", "kaki", "otak", "jus", "saus", "kue",
    "monster", "goblin", "penyihir", "ninja", "bajak laut", "ayam", "monyet", "musang", "hamster", "angsa",
    "tron", "bot", "zilla", "saurus", "nator", "master", "raja", "ratu", "tuan", "bang"
];

export const idSillyPrefixes = [
    "Pak", "Bu", "Kapten", "Profesor", "Dokter", "Tuan", "Nona", "Baron", "Duke",
    "Bahagia", "Riang", "Loncat", "Halus", "Berbulu", "Berkilau", "Cekikikan", "Goyang", "Konyol", "Gila",
    "Super", "Mega", "Ultra", "Hiper", "Turbo", "Power", "Ajaib", "Sihir", "Epik", "Keren"
];

export const idSillySuffixes = [
    "Bup", "Bop", "Bam", "Zap", "Zip", "Zum", "Pow", "Wow", "Yay", "Wii",
    "Coret", "Mie", "Pudel", "Strudel", "Jalan", "Peluk", "Sayang", "Tawa", "Goyang", "Jigel",
    "Pop", "Hop", "Mop", "Top", "Cop", "Tetes", "Flop", "Plop", "Stop", "Toko"
];

export const idGoofyNames = [
    "Si Bolang",
    "Upin Ipin",
    "Doraemon",
    "Si Juki",
    "Kabayan",
    "Pak Raden",
    "Cepot",
    "Bawang Merah",
    "Timun Mas",
    "Si Kancil",
    "Gareng",
    "Petruk",
    "Bagong",
    "Semar",
    "Godam"
];

// Vietnamese Funny Names
export const viAbsurdPrefixes = [
    "Khoai Tây", "Lò Nướng", "Gạch", "Thìa", "Muffin", "Tất", "Dưa Muối", "Chuối", "Phô Mai", "Mì",
    "Bong Bóng", "Sủi Bọt", "Glorp", "Tách", "Lắc", "Zonk", "Blorp", "Bắp Cải", "Vịt", "Đèn",
    "Bánh Flan", "Phở", "Bánh", "Bánh Quy", "Donut", "Xôi", "Muôi", "Xô", "Cây Lau", "Xà Phòng"
];

export const viAbsurdSuffixes = [
    "mặt", "đầu", "mũi", "quần", "mông", "chân", "não", "nước", "sốt", "bánh",
    "quái vật", "yêu tinh", "phù thủy", "ninja", "cướp biển", "gà", "khỉ", "chồn", "chuột", "ngỗng",
    "tron", "bot", "zilla", "saurus", "nator", "bậc thầy", "vua", "nữ hoàng", "ngài", "anh"
];

export const viSillyPrefixes = [
    "Ông", "Bà", "Thuyền Trưởng", "Giáo Sư", "Bác Sĩ", "Ngài", "Cô", "Nam Tước", "Công Tước",
    "Vui Vẻ", "Hớn Hở", "Nhảy Nhót", "Bông Xốp", "Xù", "Lấp Lánh", "Cười", "Lắc Lư", "Ngớ Ngẩn", "Điên",
    "Siêu", "Mega", "Ultra", "Hyper", "Turbo", "Sức Mạnh", "Thần Kỳ", "Ma Thuật", "Sử Thi", "Cool"
];

export const viSillySuffixes = [
    "Bụp", "Bốp", "Bùm", "Zắp", "Zíp", "Zoom", "Pow", "Wow", "Yay", "Wee",
    "Vẽ", "Mì", "Poodle", "Strudel", "Lạch Bạch", "Ôm", "Nựng", "Hí", "Lắc", "Rung",
    "Pop", "Hop", "Mop", "Top", "Cop", "Giọt", "Bịch", "Plop", "Stop", "Shop"
];

export const viGoofyNames = [
    "Tễu",
    "Thằng Bờm",
    "Trạng Quỳnh",
    "Cậu Bé Bút Chì",
    "Doraemon",
    "Tôn Ngộ Không",
    "Bảy Viên Ngọc Rồng",
    "Thằng Cuội",
    "Chú Tễu",
    "Ông Bụt",
    "Bà Chúa Xứ",
    "Sọ Dừa",
    "Cóc Tía",
    "Thánh Gióng Béo",
    "Lợn Con Bay"
];

// Russian Funny Names
export const ruAbsurdPrefixes = [
    "Картошка", "Тостер", "Кирпич", "Ложка", "Маффин", "Носок", "Огурчик", "Банан", "Сыр", "Лапша",
    "Пузырь", "Шипучка", "Глорп", "Шлёп", "Вихляй", "Зонк", "Блорп", "Капуста", "Утка", "Лампа",
    "Пудинг", "Блин", "Вафля", "Печенька", "Пончик", "Бублик", "Лопатка", "Ведро", "Швабра", "Мыло"
];

export const ruAbsurdSuffixes = [
    "лицо", "голова", "нос", "штаны", "попа", "нога", "мозг", "сок", "соус", "торт",
    "монстр", "гоблин", "волшебник", "ниндзя", "пират", "курица", "обезьяна", "хорёк", "хомяк", "гусь",
    "трон", "бот", "зилла", "завр", "натор", "мастер", "царь", "царица", "барин", "чувак"
];

export const ruSillyPrefixes = [
    "Сэр", "Мадам", "Капитан", "Профессор", "Доктор", "Господин", "Госпожа", "Барон", "Герцог",
    "Весёлый", "Радостный", "Прыгучий", "Пушистый", "Мохнатый", "Блестящий", "Хихикающий", "Шаткий", "Глупый", "Безумный",
    "Супер", "Мега", "Ультра", "Гипер", "Турбо", "Мощный", "Чудесный", "Магический", "Эпичный", "Крутой"
];

export const ruSillySuffixes = [
    "Буп", "Боп", "Бам", "Зап", "Зип", "Зум", "Пау", "Вау", "Йей", "Ви",
    "Дудл", "Лапша", "Пудель", "Штрудель", "Топ-топ", "Обнимашка", "Бубусик", "Хихи", "Вигл", "Джигл",
    "Поп", "Хоп", "Моп", "Топ", "Коп", "Кап", "Флоп", "Плоп", "Стоп", "Шоп"
];

export const ruGoofyNames = [
    "Чебурашка",
    "Крокодил Гена",
    "Кот Матроскин",
    "Шарик",
    "Печкин",
    "Винни-Пух",
    "Пятачок",
    "Карлсон",
    "Незнайка",
    "Буратино",
    "Колобок",
    "Баба-Яга",
    "Кощей",
    "Водяной",
    "Лунтик"
];

// Italian Funny Names
export const itAbsurdPrefixes = [
    "Patata", "Tostapane", "Mattone", "Cucchiaio", "Muffin", "Calzino", "Cetriolino", "Banana", "Formaggio", "Pasta",
    "Bolla", "Frizzante", "Glorp", "Splash", "Ondeggio", "Zonk", "Blorp", "Cavolo", "Anatra", "Lampada",
    "Budino", "Pizza", "Cialda", "Biscotto", "Ciambella", "Bagel", "Spatola", "Secchio", "Mocio", "Sapone"
];

export const itAbsurdSuffixes = [
    "faccia", "testa", "naso", "pantaloni", "sedere", "piedi", "cervello", "succo", "salsa", "torta",
    "mostro", "folletto", "mago", "ninja", "pirata", "pollo", "scimmia", "donnola", "criceto", "oca",
    "tron", "bot", "zilla", "sauro", "nator", "maestro", "re", "regina", "signore", "tipo"
];

export const itSillyPrefixes = [
    "Signor", "Signora", "Capitano", "Professore", "Dottore", "Messer", "Signorina", "Barone", "Duca",
    "Felice", "Allegro", "Saltellante", "Soffice", "Peloso", "Brillante", "Ridacchiante", "Traballante", "Sciocco", "Pazzo",
    "Super", "Mega", "Ultra", "Iper", "Turbo", "Potere", "Meraviglia", "Magico", "Epico", "Figo"
];

export const itSillySuffixes = [
    "Bup", "Bop", "Bam", "Zap", "Zip", "Zoom", "Pow", "Wow", "Yay", "Wii",
    "Scarabocchio", "Tagliatelle", "Barboncino", "Strudel", "Ciondolo", "Coccola", "Abbraccio", "Risatina", "Dondolo", "Tremolino",
    "Pop", "Hop", "Mop", "Top", "Cop", "Goccia", "Flop", "Plop", "Stop", "Negozio"
];

export const itGoofyNames = [
    "Pinocchio",
    "Arlecchino",
    "Pulcinella",
    "Topolino",
    "Paperino",
    "Gepetto",
    "Totò",
    "Fantozzi",
    "Lupo Alberto",
    "Cattivik",
    "Alan Ford",
    "Cocco Bill",
    "Braccio di Ferro",
    "Calimero",
    "La Pimpa"
];

// Polish Funny Names
export const plAbsurdPrefixes = [
    "Ziemniak", "Toster", "Cegła", "Łyżka", "Mufinka", "Skarpeta", "Kiszony", "Banan", "Ser", "Makaron",
    "Bańka", "Musuj", "Glorp", "Chlup", "Kołysz", "Zonk", "Blorp", "Kapusta", "Kaczka", "Lampa",
    "Pudding", "Pierogi", "Gofr", "Herbatnik", "Pączek", "Bajgiel", "Łopatka", "Wiadro", "Mop", "Mydło"
];

export const plAbsurdSuffixes = [
    "twarz", "głowa", "nos", "spodnie", "tyłek", "stopa", "mózg", "sok", "sos", "ciasto",
    "potwór", "goblin", "czarodziej", "ninja", "pirat", "kurczak", "małpa", "łasica", "chomik", "gęś",
    "tron", "bot", "zilla", "zaur", "nator", "mistrz", "król", "królowa", "pan", "kolo"
];

export const plSillyPrefixes = [
    "Pan", "Pani", "Kapitan", "Profesor", "Doktor", "Mistrz", "Panna", "Baron", "Książę",
    "Wesoły", "Radosny", "Skoczny", "Puszysty", "Kudłaty", "Błyszczący", "Chichotliwy", "Chwiejny", "Głupkowaty", "Szalony",
    "Super", "Mega", "Ultra", "Hiper", "Turbo", "Moc", "Cudo", "Magiczny", "Epicki", "Kozak"
];

export const plSillySuffixes = [
    "Bup", "Bop", "Bam", "Zap", "Zip", "Zum", "Pow", "Wow", "Jej", "Wii",
    "Bazgroł", "Kluska", "Pudel", "Strudel", "Kaczor", "Przytulanka", "Cukierek", "Chichotek", "Kołysanka", "Drżączka",
    "Pop", "Hop", "Mop", "Top", "Kop", "Kropla", "Flop", "Plop", "Stop", "Sklep"
];

export const plGoofyNames = [
    "Bolek i Lolek",
    "Reksio",
    "Miś Uszatek",
    "Koziołek Matołek",
    "Krecik",
    "Pszczółka Maja",
    "Smerfetka",
    "Papa Smerf",
    "Gargamel",
    "Kajko i Kokosz",
    "Tytus",
    "Romek",
    "A'Tomek",
    "Kapitan Żbik",
    "Pan Kleks"
];

// Dutch Funny Names
export const nlAbsurdPrefixes = [
    "Aardappel", "Broodrooster", "Baksteen", "Lepel", "Muffin", "Sok", "Augurk", "Banaan", "Kaas", "Noedel",
    "Bubbel", "Bruis", "Glorp", "Spetter", "Wiebel", "Zonk", "Blorp", "Kool", "Eend", "Lamp",
    "Pudding", "Kroket", "Wafel", "Koekje", "Donut", "Stroopwafel", "Spatel", "Emmer", "Dweil", "Zeep"
];

export const nlAbsurdSuffixes = [
    "gezicht", "hoofd", "neus", "broek", "billen", "voet", "brein", "sap", "saus", "taart",
    "monster", "kabouter", "tovenaar", "ninja", "piraat", "kip", "aap", "wezel", "hamster", "gans",
    "tron", "bot", "zilla", "saurus", "nator", "meester", "koning", "koningin", "heer", "kerel"
];

export const nlSillyPrefixes = [
    "Meneer", "Mevrouw", "Kapitein", "Professor", "Dokter", "Meester", "Juffrouw", "Baron", "Hertog",
    "Blij", "Vrolijk", "Springerig", "Pluizig", "Harig", "Glimmend", "Giechelend", "Waggelend", "Maf", "Gek",
    "Super", "Mega", "Ultra", "Hyper", "Turbo", "Kracht", "Wonder", "Magisch", "Episch", "Cool"
];

export const nlSillySuffixes = [
    "Bup", "Bop", "Bam", "Zap", "Zip", "Zoem", "Pow", "Wow", "Jee", "Wie",
    "Krabbel", "Noedel", "Poedel", "Strudel", "Waggel", "Knuffel", "Kneuzig", "Giechel", "Wiebel", "Tribbel",
    "Pop", "Hop", "Mop", "Top", "Kop", "Drup", "Flop", "Plop", "Stop", "Winkel"
];

export const nlGoofyNames = [
    "Olivier B. Bommel",
    "Tom Poes",
    "Suske en Wiske",
    "Jansen en Janansen",
    "Sjors en Sjimmie",
    "Piet Piraat",
    "Kabouter Plop",
    "Puk en Muk",
    "Bassie en Adriaan",
    "Buurman en Buurman",
    "Dombo",
    "Dikkie Dik",
    "Nijntje",
    "Dansen met Jansen",
    "Flipje"
];
